/* src/app/component/add-balace-wallet/add-balace-wallet.component.scss */
.wallet-container {
  width: 500px;
  height: 420px;
  margin: auto;
  margin-top: 10vh;
  border: 2px dashed #D0D5DD;
  padding: 24px;
  border-radius: 12px;
  background: #fff;
}
.wallet-title {
  font-size: 18px;
  font-weight: 600;
  color: #344054;
  margin-bottom: 16px;
}
.slider-box {
  width: 460px;
  height: 180px;
  margin-top: 24px;
  background-color: #F2F4F7;
  padding: 10px 30px 30px 30p;
  border-radius: 12px;
}
.slider-info {
  font-size: 14px;
  color: #667085;
  margin-top: 12px;
  margin-bottom: 24px;
}
.form-group {
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
}
.form-group label {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 6px;
  color: #344054;
}
.form-group input.form-control {
  padding: 10px;
  border: 1px solid #D0D5DD;
  border-radius: 8px;
  font-size: 14px;
  outline: none;
}
.form-group input.form-control:focus {
  border-color: #FF8C00;
}
.form-group .error {
  color: red;
  font-size: 12px;
  margin-top: 4px;
}
.suggested-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 8px;
  gap: 16px;
}
.suggested-box {
  width: 150px;
  height: 50px;
  background: #ffffff;
  border: 1px dashed #D0D5DD;
  border-radius: 8px;
  padding: 10px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.amount-text {
  font-size: 20px;
  color: #344054;
  font-weight: 500;
}
.suggested-amount {
  font-size: 14px;
  color: #344054;
  font-weight: 500;
}
.divider {
  height: 35px;
  width: 1px;
  background-color: #E4E7EC;
  margin: 0 8px;
}
.icon-right {
  font-size: 16px;
  color: #344054;
}
.or-text {
  font-size: 14px;
  color: #667085;
  font-weight: 500;
}
.apply-btn {
  background: #fff;
  color: #FF8C00;
  border: 1px solid #FF8C00;
  padding: 10px 18px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  box-shadow: 0px 6px 8px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03);
}
.button-container {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
}
.cancel-btn {
  background-color: #ffffff;
  color: #344054;
  border: 1px solid #D0D5DD;
  padding: 10px 18px;
  border-radius: 8px;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  box-shadow: 0px 6px 8px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03);
}
.add-balance-btn {
  border: none;
  padding: 10px 18px;
  border-radius: 8px;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  box-shadow: 0px 6px 8px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03);
}
.slider-wrapper {
  position: relative;
  width: 100%;
}
.custom-slider {
  -webkit-appearance: none;
  width: 100%;
  height: 8px;
  background: #F2F4F7;
  border: 1px solid #D0D5DD;
  border-radius: 4px;
  margin-top: 20px;
  outline: none;
}
.custom-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 24px;
  height: 24px;
  background: #FF8C00;
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  z-index: 2;
  border: 2px solid white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}
.custom-slider::-moz-range-thumb {
  width: 24px;
  height: 24px;
  background: #FF8C00;
  border-radius: 50%;
  cursor: pointer;
  border: 2px solid white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}
.slider-selector {
  position: absolute;
  top: -30px;
  transform: translateX(-50%);
  z-index: 3;
  pointer-events: none;
}
.slider-select-value {
  background: #FFF;
  color: #344054;
  padding: 12px 18px;
  border-radius: 16px;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  box-shadow: 8px 8px 16px rgba(0, 0, 0, 0.1);
  transform: translateX(-50%);
}
.slider-progress-bar {
  height: 8px;
  background: #FF8C00;
  border-radius: 4px 0 0 4px;
  position: absolute;
  top: 20px;
  left: 0;
  z-index: 1;
}
.pi-clone {
  cursor: pointer;
  transition: all 0.3s ease;
}
.pi-clone:hover {
  color: #FF8C00;
  transform: scale(1.1);
}
.apply-btn {
  transition: all 0.3s ease;
}
.apply-btn:active {
  transform: scale(0.95);
  background-color: #cc7000;
}
/*# sourceMappingURL=add-balace-wallet.component-HWU7SYAV.css.map */
